import { render, staticRenderFns } from "./UploadLogoModal.vue?vue&type=template&id=13512e7e&"
import script from "./UploadLogoModal.vue?vue&type=script&lang=js&"
export * from "./UploadLogoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports